import { schema } from 'normalizr';

export const taskSchema = new schema.Entity('tasks', {}, { idAttribute: 'TaskId' });

export const taskListSchema = [taskSchema];
